import { useEffect, useCallback } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage, SetupPage, ErrorPage } from '@core/authentication';
import { NotificationProvider, NotificationSystem } from '@core/ui';

function App() {
  // Theme is locked to dark mode - light mode coming later
  const theme = 'dark' as const;

  // Apply dark theme to document on mount
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
    document.documentElement.setAttribute('data-effects', 'glass');
    document.body.classList.remove('core-theme-dark', 'core-theme-light');
    document.body.classList.add('core-theme-dark');
  }, []);

  // Placeholder for when light mode is enabled
  const toggleTheme = useCallback(() => {
    // Light mode disabled - will be activated later
  }, []);

  return (
    <NotificationProvider config={{ position: 'top-right', maxVisible: 5 }}>
      <NotificationSystem>
        <Routes>
          {/* Auth routes - all under /auth/* */}
          <Route path="/auth" element={<LoginPage theme={theme} onThemeToggle={toggleTheme} />} />
          <Route path="/auth/login" element={<LoginPage theme={theme} onThemeToggle={toggleTheme} />} />
          <Route path="/auth/login/error/:errorType" element={<ErrorPage />} />
          <Route path="/auth/setup" element={<SetupPage />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route path="/auth/error" element={<ErrorPage />} />
          <Route path="/error" element={<ErrorPage />} />
          
          {/* Root redirects to /auth */}
          <Route path="/" element={<Navigate to="/auth" replace />} />
          
          {/* Catch all - redirect to /auth */}
          <Route path="*" element={<Navigate to="/auth" replace />} />
        </Routes>
      </NotificationSystem>
    </NotificationProvider>
  );
}

export default App; 